import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { t } from 'src/i18n';

import '../../library/editors/elements/d-select-tag';
import '../../library/editors/elements/d-checkbox';
import '../../library/fields/d-view-text';
import '../../library/fields/d-expansion';
import '../../library/elements/d-action';
import '../../library/elements/d-wrap';
import type { SelectTagOption } from '../../library/editors/elements/select-tag-option';
import { joinWithAnd } from 'src/utilities/text';

@customElement('d-emergency-access')
export class DEmergencyAccess extends LitElement {
  static readonly styles = css`
    :host {
      display: block;
      padding: 12px 0 10px 0;
    }
    d-checkbox {
      margin-top: 12px;
    }
  `;

  @property({ type: Object })
  fieldsByCode = {};
  @property({ type: Boolean })
  edit = false;
  @property({ type: Array })
  editValue: string[] = [];
  @property({ type: Boolean })
  currentUserHasAccess = false;
  @property({ type: Array })
  people: SelectTagOption[] = [];
  @property({ type: Array })
  accessList: string[] = [];

  private onEdit() {
    this.editValue = [...this.accessList];
    this.edit = true;
  }

  private onSave() {
    this.accessList = this.editValue;
    this.dispatchEvent(
      new CustomEvent<{ accessList: string[] }>('save-emergency-access', {
        composed: true,
        bubbles: true,
        detail: { accessList: this.accessList },
      }),
    );
    this.edit = false;
  }

  private onValueChanged(e: CustomEvent<{ value: string[] }>) {
    e.stopPropagation();
    this.editValue = [...e.detail.value];
  }

  private get accessors() {
    if (!this.edit) {
      return joinWithAnd(this.people.filter((p) => this.accessList.includes(p.value)).map((p) => p.text));
    }
    return '';
  }

  render() {
    return html`
      <div>
        <d-wrap split-reverse baseline>
          ${this.currentUserHasAccess
            ? html`<d-action>
                ${this.edit
                  ? html`<span @click=${this.onSave}>${t('content.done')}</span>`
                  : html`<span @click=${this.onEdit}>${t('content.edit')}</span>`}
              </d-action>`
            : nothing}
          <d-view-text wrap-label field="organization_emergencyAccess" value="${this.accessors}"></d-view-text>
        </d-wrap>
        <d-expansion ?opened=${this.edit}>
          <d-select-tag
            .options=${this.people}
            type="tag"
            .value=${this.editValue}
            @value-changed=${this.onValueChanged}
          >
          </d-select-tag>
        </d-expansion>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-emergency-access': DEmergencyAccess;
  }
}
